import { render } from "./CardCorner.svg?vue&type=template&id=4a3c5168"
const script = {}
script.render = render

export default script